 
import WebOffice from '../../../webOffice/index'; 

export default{
    components: {//自定义组件列表 
        'web-office':WebOffice
	},
    data() {
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'会议纪要列表', path:'/oa/meeting/minutes'
            },{
                name:'会议纪要详情', path:''
            }],
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/minutes/save',//保存
                bykey:'oa/minutes/byKey',//详情 
                roomList:'/oa/meeting/room/all',
                signList: 'oa/sign/list',//获取列表
            }, 
            editObj:{
                title:"",
                fileKey:"", 
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"",
            fileList:[],//源文件 
            userWnd: false,//是否显示人员选择窗口 
            rules:{ 
                signKey:[{ required: true, message: '请选择议题报签单', trigger: 'blur' }],
                name:[{ required: true, message: '请输入会议名称', trigger: 'blur' }], 
                meetingTime:[{ required: true, message: '请选择会议时间', trigger: 'change' }], 
                meetingRoomKey:[{ required: true, message: '请选择会议室', trigger: 'change' }], 
                address:[{ required: true, message: '请输入会议地点', trigger: 'blur' }], 
                users:[{ required: true, message: '请输入参会人员', trigger: 'blur' }], 
            },
            fileNumList:[], 
            rooms:[],
            signTableDialog:false,
            signData:[],
            selectData:[],
            total:0,
            params:{
                page:1,
                limit:20, 
            },
            webShow: false, 
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        bizKey: String,
    },
    watch: {
        bizKey() {
            this.find();
        }, 
    }, 
    mounted() {  
        this.find(); 
    },                                   
    methods: {
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params:me.key
            }).then(rsp => {
                if(rsp.success){
                    me.editObj=rsp.retObj; 
                }
            })
        },
        loadRoomList(){
            const me=this;
            me.$post({
                url: me.apis.roomList,
                params: {}
            }).then(rsp => {
                if(rsp.success){
                    me.rooms=rsp.retObj; 
                }
            })
        },
        goBack(){ 
            this.$router.go(-1);
        },  
        showUserWnd(){ 
            this.userWnd = true;
        },
        userSelected(keys, us){
            const me = this;
            if(!us || us.length <= 0){
                me.userWnd = false;
                me.$set(me.wfFlowModel, 'nextApprove', "");
                me.$set(me.wfFlowModel, 'name', "");
            }
            for(let i in us){
                let user = us[i]; 
                me.$set(me.wfFlowModel, 'nextApprove', user.id);
                me.$set(me.wfFlowModel, 'name', user.name);
               
            }
            me.userWnd = false;
        },
      
        save(verdict){ 
            const me = this, form = me.$refs['form'];
            form.validate((valid) => {
                if(!valid){ 
                    me.$message.error("请完整填写表单信息!");
                    return;
                } 
               
                me.$set(me.wfFlowModel, 'verdict', verdict); 
                if(verdict==2){ 
                    me.$set(me.wfFlowModel, 'finish', true); 
                }
                if(verdict==3){
                    me.$set(me.wfFlowModel, 'verdict', 1); 
                    me.$set(me.wfFlowModel, 'finish', true); 
                }
                me.$post({
                    url: me.apis.save,
                    params: {
                        doc:me.editObj,
                        wfFlowModel:me.wfFlowModel
                    }
                }).then(rsp => {
                    if(rsp.success){
                        this.$notify({
                            title: '成功',
                            message: '信息保存成功',
                            type: 'success',
                            duration:4000,
                            offset: 200
                        });
                        me.$router.push("/oa/meeting/minutes");
                    }
                })
            })
        },
        callback(){
            
        },
        editDoc(){
            let { href } = this.$router.resolve({
                path: "/oa/office/browerDialog",
                query: {
                    isView: 1,
                    bizKey: this.key,
                    fileType: ".docx",
                    bizType: 12,
                    fileId: this.editObj.fileKey
                }
            })
            this.winDialog = window.open(href, "_blank", " left=0,top=0,width=" + (screen.availWidth - 10) + ",height=" + (screen.availHeight - 50) + ",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
        },
        chooseSign(){
            this.loadSign();
        },
        pageChange(v){
            const me = this;
            me.$set(me.params, 'page', v);
            me.loadSign();
        },
        sizeChange(v){
            const me = this;
            me.$set(me.params, 'limit', v);
            me.loadSign();
        },
        loadSign(){
            const me=this;
            me.$post({
                url: me.apis.signList,
                params: me.params
            }).then(rsp => {
                me.total=rsp.total;
                me.signData=rsp.retList;
                me.signTableDialog=true;
            })
        },
        handleSelectionChange(val) { //报签选择
            this.selectData = val;
        },
        selectSign(){
            if(this.selectData.length!=1){
                this.$message({
                    message: '请选择一条数据!',
                    type: 'error'
                });  
                return;
            } 
            this.$set(this.editObj,'signName',this.selectData[0].name);  
            this.$set(this.editObj,'signKey',this.selectData[0].id);   
            this.signTableDialog=false; 

        },
        callback(){
            
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/meeting/minutes/view/view.js